import enLocale from 'element-ui/lib/locale/lang/en'

export default {
  ...enLocale,
  "pageTitle": {
    "index": "韩国签证申请中心--官方授权指定机构",
    "login": "账号登录",
    "retrieve": "找回密码",
    "register": "注册账号",
    "center": "个人中心",
    "userMsg": "消息中心",
    "news": "新闻中心",
    "serviceCenter": "客户服务中心",
    "clientCenter": "客户中心",
    "tour": "旅游信息",
    "tourList": "旅游信息",
    "orderList": "我的订单",
    "orderDetail": "订单详情",
    "applyTodoList": "待办申请列表",
    "changePhone": "更换手机",
    "address": "常用地址",
    "addressDetail": "地址详情",
    "setting": "设置",
    "aboutUs": "关于我们",
    "contactUs": "联系我们",
    "businessCooperation": "商务合作",
    "FAQ": "常见问题",
    "feedback": "意见反馈",
    "changePsd": "修改密码",
    "choiceVisaType": "签证申请",
    "saveBasicInfo": "签证申请信息",
    "saveApplyInfo": "签证申请信息",
    "visaInformation": "签证申请信息",
    "confirmApply": "签证申请信息",
    "applicantInfo": "申请人信息",
    "sendMaterials": "申请寄送材料",
    "sendDataInfo": "签证申请",
    "receiveDataInfo": "签证申请",
    "visaData": "签证所需资料",
    "confirmPay": "确认支付",
    "msgList": "消息中心",
    "law": "韩国基本法秩序",
    "visaCenter": "签证中心",
    "siteMap": "网站地图",
    "paySuccess": "订单支付",
    "agreement": "用户协议",
    "invoiceList": "发票抬头",
    "invoiceDetail": "添加发票抬头",
    "generateFormSuccess": "生成申请表成功",
    changeEmail: "更换邮箱",
    applyInvoice: "申请发票",
    expressInfo: "物流信息",
    visaInQuery: "办理进度查询",
    TravelAgencyIdentity: "旅行社身份申请",
    queryResults: "查询结果",
  },
  header: {
    title: "Welcome to visit Korea Visa Application Center",
    login: {
      unLogin: {
        login: "login",
        register: "Registered account",
      },
      logined: {
        order: "My order",
        todoList: "In the application",
        message: "Message center",
        address: "Usual Address",
        changePsd: "Change the password",
        changePhone: "Change phone number",
        changeEmail: "Replace the email",
        logout: "Log out",
      },
    },
    todoList: "In the application",
    lang: "English",
    nav: {
      index: "HOME",
      visa: "The visa application",
      query: "Enquiry of visa application",
      news: "News",
      client: "Customer center",
      tour: "Tourist information",
      law: "Law",
      aboutUs: "About us",
    },
    menu: {
      guide: "The visa guide",
      procedures: "Visa procedures",
      application: "The visa application",
      query: "Distributed query",
      'offline booking': "Offline booking"
    },
    visas: "Number of granted visas",
    number: "",
  },
  /*---------------------------   客户中心     --------------------------*/
  serviceCenter: {
    title: "Customer center",
    home: "HOME",
    'Customer center': "Customer center",
    'Customer service center': "Customer service center"
  },
  /*---------------------------   旅游信息     --------------------------*/
  tour: {
    'Tourist information': "Tourist information",
    'HOME': "HOME",
    'hot spots': "hot spots",
    'Theme travel': "Theme travel"
  },
  /*---------------------------   新闻中心     --------------------------*/
  news: {
    HOME: "HOME",
    NEWS: "NEWS",
    LAW: "LAW"
  },
  /*---------------------------   登录页     --------------------------*/
  "login": {
    Copyright: "Korea Online Visa Application Center",
    "title": {
      "s1": "If you don't have an account？",
      "s2": "Registered account"
    },
    "welcome": "Welcome to login",
    loginType: {
      type1: "login",
      type2: "Log in to a travel agency"
    },
    "form": {
      "mobile": {
        "name": "手机号",
        "placeholder": "Please enter your mobile phone number"
      },
      "password": {
        "name": "密码",
        "placeholder": "Please enter your password"
      },
      account: {
        "name": "账号",
        "placeholder": "Please enter the travel agency account number"
      },
      "authCode": {
        "name": "验证码",
        "placeholder": "Please enter the graphic verification code"
      }
    },
    "rulesErr": {
      'mobile is required': "Please fill in your cell phone number",
      "mobile is not correct": "The phone number is incorrect",
      "account is required": "Please enter the travel agency account number",
      "password is required": "Please fill in the password",
      "password is not correct": "Please enter a reset password: Six to twenty",
      "authCode is required": "Please fill in the verification code"
    },
    "loginMore": {
      "Remember account": "Remember account",
      "retrieve": "Forgot password？",
      "register": "注册账号"
    },
    "loginBtn": "Sign in",
    "logging": "正在登陆"
  },
  "retrieve": {
    "title": {
      "s1": "No account？",
      "s2": "please register"
    },
    retrieve: "Retrieve password",
    retrieveType: {
      type1: "Use your cell phone number to retrieve your password.",
      type2: "Find password by email"
    },
    "form": {
      "mobile": {
        "name": "手机号",
        "placeholder": "Please enter your mobile phone number"
      },
      "email": {
        "name": "邮箱",
        "placeholder": "Please enter your email address for registration"
      },
      "picCode": {
        "name": "图形验证",
        "placeholder": "Please enter the graphic verification code"
      },
      "authCode": {
        "name": "验证码",
        "placeholder": "Please enter the graphic verification code"
      },
      "resetPsd": {
        "name": "重置密码",
        "placeholder": "Please enter a reset password: Six to twenty"
      },
      "confirmPsd": {
        "name": "确认密码",
        "placeholder": "Reconfirm to reset the password"
      }
    },
    "rulesErr": {
      'mobile is required': "Please fill in your mobile phone number",
      "mobile is not correct": "The phone number is incorrect",
      "picCode is required": "Please enter the graphic verification code",
      "authCode is required": "Please enter the graphic verification code",
      "resetPsd is required": "Please fill in the reset password",
      "confirmPsd is required": "Reconfirm to reset the password",
      "psdNumber is not correct": "Please enter a reset password: Six to twenty",
      "inconsistent password": "The passwords entered are inconsistent",
      "email is required": "Please fill in the registration email",
      "email is not correct": "Please enter the correct email address"
    },
    "authBtn": "get a verification code",
    "resetPsdBtn": "To reset your password"
  },
  /*---------------------------   注册页     --------------------------*/
  "register": {
    'Welcome to register': "Welcome to register",
    "title": {
      "s1": "If you have an account？",
      "s2": "please log in"
    },
    "form": {
      "mobile": {
        "name": "手机号",
        "placeholder": "Please enter 11 cell phone numbers"
      },
      "picCode": {
        "name": "图形验证",
        "placeholder": "Please enter the graphic verification code"
      },
      "authCode": {
        "name": "验证码",
        "placeholder": "Please enter the graphic verification code"
      },
      "email": {
        "name": "邮箱",
        "placeholder": "Please enter your email address"
      },
      "password": {
        "name": "密码",
        "placeholder": "Please enter a reset password: Six to twenty"
      },
      "confirmPsd": {
        "name": "重复密码",
        "placeholder": "Please enter your password again"
      }
    },
    "rulesErr": {
      'mobile is required': "Please fill in your cell phone number",
      "mobile is not correct": "The phone number is incorrect",
      "picCode is required": "Please enter the graphic verification code",
      "authCode is required": "Please enter the graphic verification code",
      "password is required": "Please fill in the password",
      "confirmPsd is required": "Please enter your password again",
      "psdNumber is not correct": "Please enter a reset password: Six to twenty",
      "inconsistent password": "The passwords entered are inconsistent",
      "email is required": "Please enter your email address",
      "email is not correct": "邮箱格式不正确",
      "protocol is required": "请先同意注册协议"
    },
    "agreement": {
      "s1": "Agree to",
      "s2": "user registration license agreement"
    },
    "registerBtn": "Sign up",
    "loading": "Sign up",
    "authBtn": "get a verification code"
  },
  /*---------------------------   修改密码    --------------------------*/
  "changePsd": {
    "form": {
      "oldPsd": {
        "name": "旧密码",
        "placeholder": "请输入旧密码"
      },
      "newPsd": {
        "name": "新密码",
        "placeholder": "请输入新密码"
      },
      "confirmPsd": {
        "name": "新密码",
        "placeholder": "请再次输入新密码"
      },
      "authCode": {
        "name": "验证码",
        "placeholder": "请输入验证码"
      },
    },
    "rulesErr": {
      "oldPsd is required": "请输入原密码",
      "newPsd is required": "请输入新密码",
      "confirmPsd is required": "请再次输入新密码",
      "authCode is required": "请输入验证码",
      "psdNumber is not correct": "请填写6至20位密码",
      "inconsistent password": "The passwords entered are inconsistent",
    },
    "cancelBtn": "取消",
    "confirmBtn": "确定"
  },
  /*首页*/
  index: {
    navTitle: {
      title1: "公告事项",
      title2: "新闻中心",
      title3: "旅游信息",
    },
    consulting: "news",
    Notice: "Notice",
    procedures: {
      procedures: "Visa procedures ",
      'Add Applicants': "Add Applicants",
      'Fill in the information': "Fill in the information",
      'Postal information entry': "Postal information entry",
      'Confirm and pay': "Confirm and pay",
      'Waiting for the visa': "Waiting for the visa",
      'Visa application result': "Visa application result"
    },
    visaCenter: 'Korea Visa Application Center',
    'Consulate information': "Consulate information",
    'Convenient service': "Convenient service",
    service: {
      'division of jurisdictions': "division of jurisdictions",
      'Visa application form download': "Visa application form download",
      'Common problems': "Common problems",
      'Other materials download': "Other materials download",
    },
    link: "link"
  },
  footer: {
    'reminder': 'reminder：The destination pictures and information used in this website (PC, applet, official account) are provided by the Koraa Tourism Organization.',
    'About us': "About us",
    'Contact us': "Contact us",
    'feedback': "feedback",
    'business cooperation': "business cooperation",
    'App download': "App download",
    'Site map': "Site map",
    'User agreement': "User agreement",
  },
  /*---------------------------   个人中心     --------------------------*/
  "center": {
    "userMsg": "Message center",
    "orderList": "My order",
    "applyTodoList": "In the application",
    "address": "Usual Address",
    "invoiceTitle": "Invoice name",
    "feedback": "feedback",
    "logout": "Log out",
    "changePhone": "更换手机",
    "changePsd": "修改密码",
    "setting": "设置",
    logoutNotice: "Would you like to log out?",
    'Working days': "Working days"
  },
  aboutUs: {
    'HOME': "HOME",
    'Site map': "Site map",
    'About us': "About us",
    'Contact us': "Contact us",
    'Business cooperation': "Business cooperation",
  },
  /*---------------------------   消息中心     --------------------------*/
  "userMsg": {
    "navTitle": {
      "title1": "系统消息",
      "title2": "公告消息"
    }
  },
  /*---------------------------   签证中心     --------------------------*/
  "visaCenter": {
    "Working hours and contact information": 'Working hours and contact information',
    "Visa fee description": 'Visa fee description',
  },
  /*---------------------------   我的订单     --------------------------*/
  "orderList": {
    title: "My order",
    Name: "Name",
    to: "to",
    'Passport no': "Passport no",
    'jurisdictions': "jurisdictions",
    'Express service1': "Express service",
    'Id card number': "Id card number",
    'Application date': "Application date",
    'Sub account': "Sub account",
    'Express service2': "Express service",
    'Mobile phone no': "Mobile phone no",
    'Creation time': "Creation time",
    'The order number': "The order number",
    'Order Amount': "Order Amount",
    'Send a single number': "Send a single number",
    'The name': "The name",
    'To apply for the jurisdictions': "To apply for the jurisdictions",
    'state': "state",
    'operation': "operation",
    "navTitle": {
      "title1": "全部订单",
      "title2": "进行中",
      "title3": "已完成"
    },
    "orderItem": {},
    nav1: "HOME",
    nav2: "Personal center",
    nav3: "My order",
    screening: "screening",
    empty: "empty",
    "view": "view",
    "Expand": "Expand",
    "Check the invoice": "Check the invoice",
    "To apply for the invoice": "Request Invoice",
    "To apply for the invoice1": "Invoicing",
    "To apply for the invoice2": "Download invoice",

    "Profile picture": "Profile picture",
    "Name/pinyin": "Name/pinyin",
    "Passport number": "Passport number",
    "Gender": "Gender",
    "Application type": "Application type",
    "Domicile place": "Domicile place",
    "Reply mode": "Reply mode",
    "Application status": "Application status ",


    "Start date": "Start date",
    "end date": "end date"
  },
  /*---------------------------   订单详情     --------------------------*/
  "orderDetail": {
    "use one mailing address1": "This ",
    "use one mailing address2": " people, use one mailing address",
    "The recipient": "The recipient", "Mobile phone number": "Mobile phone number", "address": "address",
    "Visa fee（consulate charges）": "Visa fee（consulate charges）",
    "Visa service charge（Visa center charges）": "Visa service charge（Visa center charges）",
    "The urgent charge": "The urgent charge（consulate charges）",
    title: "The order details",
    nav1: "HOME",
    nav2: "Personal center",
    nav3: "My order",
    "The order number": "The order number",
    "Creation time": "Creation time",
    "Check the application form": "Check the application form",
    "Delivery charge": "Delivery charge",
    "Delivery check": "Delivery check",
    "return express fee": "return express fee",
    "Click to view the required materials": "Click to view the required materials",
    "Send the required materials to the e-mail": "Send the required materials to the e-mail",
    "The payment information": "The payment information",
    "Payment amount": "Payment amount",
    "payment": "payment",
    "payment method": "payment method",
    "Payment time": "Payment time",
    "navTitle": {
      "title1": "签证详情",
      "title2": "快递详情"
    },
  },
  /*---------------------------   待办申请列表     --------------------------*/
  "applyTodoList": {
    title: "In the application",
    "Waiting list": "Waiting list",
    "attention": "attention ：Only the same consular area can merge the order",
    "maximum": "Your order will be delivered in the same way(Maximum 5 people can apply)",
    "Please select an applicant": "Please select an applicant",
    'Visa procedures': "Visa procedures",
    'Add Applicants': "Add Applicants",
    'Fill in the information': "Fill in the information",
    'Fill in the mailing information': "Fill in the mailing information",
    'Confirm and pay': "Confirm and pay",
    'Waiting for the visa': "Waiting for the visa",
    'Pick up or send visa results': "Pick up or send visa results",
    "s1": "办签流程",
    confirmBtn: "确认并下单",
    "Add applicant": "Add applicant"
  },
  /*---------------------------   消息列表     --------------------------*/
  msgList: {
    'Message center': "Message center",
    'System message': "System message",
    'Notice': "Notice",
  },
  /*---------------------------   发票抬头     --------------------------*/
  invoiceList: {
    title: "Invoice name",
    'Add receipt name': "Add receipt name",
    'type': "type",
    'Contact phone number': "Contact phone number",
    'email': "email",
    'Invoice name': "Invoice name",
    'other': "other",
    'operation': "operation",
  },
  /*---------------------------   意见反馈     --------------------------*/
  feedback: {
    nav1: "HOME",
    nav2: "Personal center",
    'title': "feedback",
    'Feedback information': "Feedback information",
    "Submit feedback": "Submit feedback",
    "Over 6 words": " Over 6 words, less than 200 words",
  },
  /*---------------------------   地址列表     --------------------------*/
  addressList: {
    title: "Usual Address",
    'Add new address': "Add new address",
    'The recipient': "The recipient",
    'region': "region",
    'Detailed address': "Detailed address",
    'Mobile phone number': "Mobile phone number",
    'operation': "operation",
  },
  /*---------------------------   签证申请类型页面     --------------------------*/
  choiceVisaType: {
    "WeChat customer service": 'WeChat customer service',
    "contact number": 'Contact number',
    "Email consultation": 'Email consultation',
    "Official website": 'Official website',
    "Select visa center": 'Select visa center',
    "Select visa center tips": 'Select the visa center to display the permanent living and working cities accepted by the current visa center. (The permanent living and working city shall be subject to the local social security or residence card)',
    "Purpose of visit": 'Purpose of visit',
    "Type of visa": 'Type of visa',
    "Issued to": 'Issued to',
    "Do you need help": 'Do you need help?',
    "View Example": 'Example',
    "Download files": 'Download files',
    "On line printing and filling": 'On line printing and filling',
    "Description of Expenses": "Description of Expenses",
    "Visa fee（consulate charges）": "Visa fee（consulate charges）",
    "Visa service charge（Visa center charges）": "Visa service charge（Visa center charges）",
    "The urgent charge": "The urgent charge（consulate charges）",
    "Click to view the required materials": "Click to view the required materials",
    "Send the required materials to the e-mail": "Send the required materials to the e-mail",
    "Urgent or not": 'Urgent or not',
    "attention": "attention",
    "urgent service1": "Urgent service charge is RMB ",
    "urgent service2": "RMB/person",
    "Visa Description": "Visa Description",
    "The urgent is only based": "The urgent is only based on the priority review of documents, and has nothing to do with the visa issuance time and success rate.",
    "Application Form fill in type": "Application Form fill in mode",
    "Apply": "Apply",
    title: "The visa application",
    "container": {
      "s1": "韩国签证申请中心",
    },
    confirmBtn: "Start processing",
    form: {
      letter: {
        s1: 'I have fully understood and confirmed',
        s2: '《Personal Information Protection Notice》',
        s3: 'and',
        s4: '《User Privacy Policy》',
        s5: '',
        s6: 'I agree to submit all the information required for visa application, as well as the originals and copies of various supporting materials.',
      },
      mode: {
        name: 'matters needing attention：',
        s1: '1. The applicant must fill in the application form truthfully, completely and accurately',
        s2: '2. Be sure to print the application form and submit it with the materials',
        s3: '3. In the process of visa review, if the Consulate General deems it necessary, it may require the applicant to submit supplementary materials or ask for an interview with the applicant',
        s4: '4. The ID card, residence booklet, marriage certificate and other personal identity information materials or the original photo and other subsidy materials will be returned together with the passport after receiving (reviewing), and other materials will not be returned',
        s5: '5. The visa fee will not be refunded after the visa application',
      },
      location: {
        name: "Choose the place where you live and work",
        s1: "最终受理领区要以常住生活工作城市为准，即：在当地拥有社保或居住卡为准。",
        s2: "您的申请将提交到"
      },
      'Visa type': "Visa type",
      'Visa entries': "Visa entries",
      'The urgent': "The urgent",
      'Required materials': "Required materials",
      type: {
        name: "选择签证类型"
      },
      period: {
        name: "选择有效期",
        s1: "Number of entries：",
        s2: "Days of stay：",
        s3: "term of validity：",
        s4: "Handling time：",
      },
      expedited: {
        normal: "Normal handling",
        expedited: "Urgent handling"
      },
      urgent: {
        name: "matters needing attention：",
        s1: "Urgent processing requires an additional service charge of ",
        s2: " yuan/person",
        s3: "The time for urgent visa review is 3 working days",
        s4: "Express service will not be available for urgent visa",
      },
      datum: {
        name: "Information required",
        button: "所需资料发送到邮箱"
      }
    },
    rulesErr: {
      "locationValue is required": "请选择常住生活/工作所在地",
      "visaTypeValue is required": "请选择签证类型",
      "visaProductValue is required": "请选择有效期"
    }
  },
  savePassport: {
    "upload a passport photo": "upload a passport photo",
    "View sample image": "View sample image",
    "If it is not China, please fill in manually": "If it is not China, please fill in manually",
    container: {
      s1: "以下内容为自动识别内容，请仔细检查，如有问题可直接修改",
    },
    form: {
      passportNum: {
        name: "Passport number",
        placeholder: "",
      },
      surnameZh: {
        name: "Name（Chinese）",
        placeholder: ""
      },
      nameZh: {
        name: "Given Name（Chinese）",
        placeholder: ""
      },
      surnameEn: {
        name: "Family Name（English）",
        placeholder: ""
      },
      nameEn: {
        name: "Given Name（English）",
        placeholder: ""
      },
      gender: {
        name: "Gender",
        male: 'male',
        female: 'female'
      },
      birthDate: {
        name: "Date of birth",
        placeholder: "Select Date"
      },
      birthPlaceZh: {
        name: "Place of birth",
        placeholder: ""
      },
      birthPlaceEn: {
        name: "Country of birth",
        placeholder: ""
      },
      issuancePlaceZh: {
        name: "place of issue",
        placeholder: ""
      },
      issuancePlaceEn: {
        name: "签发地点（英文）",
        placeholder: ""
      },
      issuanceDate: {
        name: "Date of Issue",
        placeholder: "Select Date"
      },
      issuancePeriod: {
        name: "Effective Date",
        placeholder: "Select Date"
      },
    },
    "rulesErr": {
      'passportNum is required': "Please fill in your passport number",
      'requiredCount': " Must not exceed #num# characters in length",
      "surnameZh is required": "Please enter the name（Chinese）",
      "surnameEn is required": "Please enter the surname（English）",
      "nameZh is required": "Please enter the given name（Chines）",
      "nameEn is required": "Please enter the given name（English）",
      "surnameEn is not correct": "姓（英文）不正确",
      "nameEn is not correct": "名（英文）不正确",
      "birthPlaceZh is required": "Please fill in the place of birth",
      "passportSex is required": "请选择性别",
      "birthPlaceEn is required": "请填写出生国家",
      "issuancePlaceZh is required": "Please fill in the place of issue",
      "issuancePlaceEn is required": "请填写签发地点（英文）",
      "birthDate is required": "Please select a date of birth",
      "issuanceDate is required": "Please select the date of issue",
      "issuancePeriod is required": "Please select a valid date",
      "date is not correct": "结束时间不能早于开始时间"
    },
    reUploadBtn: "重新上传",
    save2next: "保存，并下一步"
  },
  uploadIdCardFront: {
    "Upload id card": "Upload id card",
    "attention": "attention ：Id photo is not clear when the system can not recognize the content, please focus on the check.Minor children do not apply for an id card, please upload the medical certificate of birth.",
    "Upload id card front": "Upload id card front",
    desc: "以下内容为自动识别内容，请仔细检查，如有问题可直接修改",
    form: {
      name: {
        title: "Name",
        placeholder: "Please fill in your name"
      },
      gender: {
        title: "Gender",
        value1: "male",
        value2: "female",
      },
      nation: {
        title: "ethnic groups",
        placeholder: "Please fill in ethnic groups"
      },
      birthDay: {
        title: "Date of birth",
        placeholder: "Select Date"
      },
      address: {
        title: "address",
        placeholder: "Please fill in the address"
      },
      idCardNo: {
        title: "Id card number",
        placeholder: "Please fill in your id card number"
      },
      reUploadBtn: "重新上传",
      save2nextBtn: "下一步"
    },
    rulesErr: {
      "name is required": "Please fill in your name",
      'idcardNumber': "Please enter the correct ID number",
      "gender is required": "请选择性别",
      "nation is required": "Please fill in ethnic groups ",
      "birthDate is required": "Please select a date of birth",
      "address is required": "Please fill in the address",
      "idCardNo is required": "Please fill in your id card number",
    }
  },
  uploadIdCardBack: {
    "Minorchild, did not handle id card": "Minorchild, did not handle id card",
    desc: "以下内容为自动识别内容，请仔细检查，如有问题可直接修改",
    "Upload id card back": "Upload id card back",
    "Minor child, did not handle id card": "Minor child, did not handle id card",
    "attention": "attention ：For minor children, the original and copy of birth medical certificate should be provided in the mailing materials without id card, and the original photo should be uploaded",
    "Upload medical certificate of birth": "Upload medical certificate of birth",
    form: {
      datePlaceholder: "Select Date",
      idcardAuthority: {
        title: "Issuing authority",
        placeholder: "Please fill in the issuing authority"
      },
      cardNumber: {
        title: "Id card number",
        placeholder: "Please fill in your id number"
      },
      idcardDate: "Effective Date",
      idcardForever: "Long-term identity card",
      longEffective: "long term effective"
    },
    rulesErr: {
      "idcardAuthority is required": "Please fill in the issuing authority",
      "idcardStartDate is required": "Please select a start date",
      "idcardEndDate is required": "Please select an end date",
      "date is not correct": "结束日期不能早于开始日期",
    }
  },
  uploadAvatar: {
    "Upload ID picture": "Upload ID picture",
    "attestation photo manual": "attestation photo manual:",
    "desc1": "1、2 white background color photos taken in the last 6 months;",
    "desc2": "2、Photos sent by mail and uploaded photos must match。",
    "desc3": "3、Do not wear glasses, exaggerated jewelry or uniforms. Look straight into the camera with both eyes; Show your ears; Mouth closed; Hair can not cover the eyes; Balance your left and right shoulders;",
    "desc4": "4、Cannot be appearance changed, photograph discoloration, fade wait for a reason, with present appearance produce apparent difference。",
    "desc5": "*We provide photo self-shooting and printing service, please choose when you order",
    "Check it and go to the next page": "Check it and go to the next page"
  },
  bankCard: {
    "Upload ID picture": "Upload ID picture",
    "attestation photo manual": "attestation photo manual:",
    "desc1": "1、2 white background color photos taken in the last 6 months;",
    "desc2": "2、Photos sent by mail and uploaded photos must match。",
    "desc3": "3、Do not wear glasses, exaggerated jewelry or uniforms. Look straight into the camera with both eyes; Show your ears; Mouth closed; Hair can not cover the eyes; Balance your left and right shoulders;",
    "desc4": "4、Cannot be appearance changed, photograph discoloration, fade wait for a reason, with present appearance produce apparent difference。",
    "desc5": "*We provide photo self-shooting and printing service, please choose when you order",
    "Check it and go to the next page": "Check it and go to the next page"
  },
  savePersonalInfo: {
    title: "Personal information",
    attention: "Please fill in true and valid information when filling in the application form, otherwise the application will be rejected",
    "question1": "*Have you entered or left Korea under any other name？",
    "surnameZh": "Other Name (the surname)",
    "nameZh": "Other Name(name)",
    "question2": "*Whether you have dual nationality？",
    "orderNationality": "*Nationality of other countries",
    "surnameZhPlaceholder": "Please fill in your Other surname",
    "nameZhPlaceholder": "Please fill in your Other Name",
    "orderNationalityPlaceholder": "Enter country name",
    "question3": "*Do you have other passports？",
    "question4": "*Other passport types",
    "passportType": {
      "type1": "Diplomatic passport",
      "type2": "Official passport",
      "type3": "Ordinary passport",
      "type4": "other"
    },
    "passportNum": {
      name: "*Passport number",
      placeholder: "Please fill in your passport number"
    },
    "issuancePlace": {
      name: "*issuing country",
      placeholder: "Please fill in your issuing country"
    },
    issuancePeriod: {
      name: "*Validity Period",
      placeholder: " Please select the expiration date"
    },
    "issuanceOrg": {
      name: "*签发机关",
      placeholder: "请输入签发机关"
    },
    rulesErr: {
      "usedOtherName is required": "请选择是否曾用名",
      "holdOtherCountry is required": "请选择是否拥有双重国籍",
      "holdOtherPassport is required": "请选择是否拥有其他护照",
      "surnameZh is required": "Please fill in your the surname（Chinese）",
      "nameZh is required": "Please fill in your Other Name（Chinese）",
      "orderNationality is required": "Enter country name",
      "passportNum is required": "Please fill in your passport number",
      "issuancePlace is required": "Please fill in your issuing country",
      "issuancePeriod is required": "Please select the expiration date",
      "issuanceOrg is required": "请输入签发机关",
      "otherPassportType is required": "请选择护照类型",
    },
    "yes": "YES",
    "no": "NO",
    "save2nextBtn": "保存，并下一步"
  },
  SaveContactInfo: {
    title: "Contact Information",
    description: "填写申请表时，请填写真实有效信息，否则将导致拒签",
    address: "*Home address",
    addressPlaceholder: "Please enter the detailed address",
    nowAddress: "*Current residential address",
    desc: "If the current residential address is different from the home address, it needs to be filled in",
    nowAddressPlaceholder: "Please enter the current address of residence",
    mobile: "*Mobile phone number",
    mobilePlaceholder: "Please enter your mobile phone number",
    telephone: "*phone number",
    telephonePlaceholder: "Please enter your telephone number",
    email: "*e-mail",
    emailPlaceholder: "Please enter your e-mail address.",
    "Emergency contact information": "Emergency contact information",
    "The surname": "The surname(English)",
    "Name": "Name(English)",
    "Please enter the last name of the emergency contact": "Please enter the last name of the emergency contact",
    "Please enter the name of the emergency": "Please enter the name of the emergency",
    emergencyContact: "*Emergency contact",
    contactName: "*Name",
    contactNamePlaceholder: "请输入紧急联系人姓名",
    contactMobile: "*phone number",
    contactMobilePlaceholder: "Please enter an emergency contact phone number",
    contactNationValuePlaceholder: "Please enter emergency contact country of residence",
    emergencyRelationshipPlaceholder: "Please enter a relationship with the emergency contact",
    contactNation: "*Country of residence",
    contactRelation: "*Relationship with the applicant",
    save2nextBtn: "保存，并下一步",
    rulesErr: {
      "address is required": "Please enter the detailed address",
      "nowAddress is required": "Please enter the current address of residence",
      "mobile is required": "Please enter your mobile phone number",
      "telephone is required": "Please enter your telephone number",
      "email is required": "Please enter your e-mail address",
      "contactName is required": "请输入紧急联系人姓名",
      "contactMobile is required": " Please enter an emergency contact phone number",
      "contactNationValue is required": "Please enter emergency contact country of residence",
      "contactRelationValue is required": "Please enter a relationship with the emergency contact",
    }
  },
  saveMemberInfo: {
    title: "Family member information",
    maritalStatus: {
      title: "*Marital status",
      status1: "married",
      status2: "divorce",
      status3: "single ",
    },
    spouseInfo: {
      title: "*spouse information",
      surnameZh: "The surname(English)",
      surnameZhPlaceholder: "Please enter your spouse's last name",
      nameZh: "Name(English)",
      nameZhPlaceholder: "Please enter your spouse's name",
      birthDate: "*Date of birth",
      birthDatePlaceholder: "Please select a date of birth",
      nationality: "*nationality",
      nationalityPlaceholder: "Please enter nationality",
      mobile: "*phone number",
      mobilePlaceholder: "Please enter your spouse's phone number",
      address: "*residential address",
      addressPlaceholder: "Please enter residential address"
    },
    haveChild: {
      question: "*Have children or not?",
      yes: "YES",
      no: "NO",
      childrenCount: {
        title: "the number of children",
        placeholder: "Please enter the number of children",
      }
    },
    rulesErr: {
      "surnameZh is required": "Please enter your spouse's last name",
      "marital is required": "请选择婚姻状况",
      "nameZh is required": "Please enter your spouse's name",
      "birthDate is required": "Please select a date of birth",
      "contactNationValue is required": "Please enter nationality",
      "mobile is required": "Please enter your spouse's phone number",
      "address is required": "Please enter residential address",
      "childrenCount is required": "Please enter the number of children",
      "haveChild is required": "请选择是否有子女",
    },
    save2nextBtn: "保存，并下一步"
  },
  saveEducationInfo: {
    title: "educational information",
    "Professional information": "Professional information",
    educationBg: {
      title: "*the highest academic qualifications",
      value1: "Master/doctor",
      value2: "Bachelor's degree",
      value3: "High school",
      value4: "other",
    },
    otherEducationBg: "*Other qualifications please specify",
    educationDescriptionPlaceholder: "Please enter other qualifications",
    universityNamePlaceholder: "Please enter the name of the school",
    universityPlacePlaceholder: "Please enter the school location",
    schoolName: "*School name",
    schoolLocation: "*School location",
    profession: {
      title: "*The current career",
      value1: "entrepreneurs",
      value2: "self-employment",
      value3: "Company employees",
      value4: "Civil servants",
      value5: "students",
      value6: "unemployed",
      value7: "retired",
      value8: "other",
    },
    occupationDescription: "*Other job description",
    occupationDescriptionPlaceholder: "Please enter other job description",
    organizationName: "*Name of company/agency/school",
    organizationNamePlaceholder: "Please enter name of company/agency/school",
    organizationPosition: "*Occupation/course",
    organizationPositionPlaceholder: "Please enter occupation/course",
    organizationAddress: "*Company/office/school address",
    organizationAddressPlaceholder: "Please enter company/office/school address",
    organizationPhone: "*Company/office/school contact number",
    organizationPhonePlaceholder: "Please enter company/office/school contact number",
    otherProfession: "*其它职业，请说明",
    save2nextBtn: "保存，并下一步",
    rulesErr: {
      "education is required": "请选择学历",
      "occupation is required": "请选择职业",
      "educationDescription is required": "Please enter other qualifications",
      "universityName is required": "Please enter the name of the school",
      "universityPlace is required": "Please enter the school location",
      "occupationDescription is required": "Please enter other job description",
      "organizationName is required": "Please enter name of company/agency/school",
      "organizationPosition is required": "Please enter occupation/course",
      "organizationAddress is required": "Please enter company/office/school address",
      "organizationPhone is required": "Please enter company/office/school contact number",
    },

  },
  saveAccessInfo: {
    title: "access information",
    Application: {
      title: "*Application for entry",
      value1: "tours /transit",
      value2: "attend a meeting,etc",
      value3: "Medical tourism",
      value4: "Short-term business",
      value5: "Learning/training",
      value6: "Employment activities",
      value7: "Trade/investment/Posting",
      value8: "to visit relatives/friends",
      value9: "to marry/immigrate",
      value10: "foreign/public affairs",
      value11: "Other",
      other: "Other Immigration Arrangements",
      otherPlaceholder: "Please enter other Immigration Arrangements"
    },
    access: {
      "days of detention": {
        title: "*days of detention",
        value1: "Less than 90 days (inclusive)",
        value2: "More than 91 days (inclusive)",
        value3: "permanent",
      },
      "Date of departure": "Date of departure",
      date: "*Intended date of entry",
      datePlaceholder: "Intended date of entry",
      days: "*拟滞留天数",
      mobile: "*Contact number in Korea",
      address: "*Address/hotel in Korea"
    },
    families: {
      question: "*Are there any family members with you？",
      yes: "YES",
      no: "NO",
      family: {
        surname: "The surname(English)",
        Name: "Name(English)",
        birth: "Date of birth",
        nationality: "nationality",
        Relationship: "Relationship with applicant",
      },
      error: {
        surname: "Please enter your English last name",
        surnameErr: "请输入正确的英文姓",
        Name: "Please enter your English name",
        NameErr: "请输入正确的英文名",
      },
      "Add fellow pedestrians": "Add fellow pedestrians"
    },
    records: {
      question1: "*Have you visited the rok in the past five years？",
      "Purpose of recent visit": "Purpose of recent visit",
      "Visit purpose": "Visit purpose",
      "During the visit": "During the visit",
      count: "*五年内访韩次数",
      purpose: "*近期入境目的",
      question2: "*Have you visited any other countries other than Korea in the last five years？",
      countries: {
        title: "其它访问国家",
        name: "*Country name (English)",
        purpose: "*Visit purpose",
        period: "During the visit"
      },
      dateStartPlaceholder: "The start time",
      dateEndPlaceholder: "cut-off time",
      yes: "YES",
      no: "NO",
      "Add Access Log": "Add Access Log",
      "Add Visiting Country": "Add Visiting Country",
    },
    haveInKorea: {
      question: "* Are there any family members living in Korea？",
      family: {
        title: "在韩家属",
        familyName: "*Name (English)",
        familyBirthDate: "*Date of birth",
        familyCountry: "*nationality",
        familyRelationship: "*Relationship with applicant"
      },
      yes: "YES",
      no: "NO",
      nameErr: "请输入正确的英文姓名",
      "Add family members living in Korea": "Add family members living in Korea",
      relationship: {
        value1: "spouse",
        value2: "children",
        value3: "parents",
        value4: "Brothers and sisters",
      }
    },
    rulesErr: {
      "date is required": "Please enter the intended date of entry",
      "phone is required": "Only allow numbers 0-9",
      "days is required": "请填写拟滞留天数",
      "mobile is required": "Contact number in Korea",
      "address is required": "Please fill in the address of your stay in Korea",
      "name is required": "请填写同行家属姓名",
      "birthDate is required": "Please select your family's birthday",
      "country is required": "Please fill in the nationality of your relative",
      "relationship is required": "请选择与同行家属关系",
      "visitedValue is required": "请选择近五年是否访问过韩国",
      "visitedPurposeValue is required": "Please enter your purpose of recent visit",
      "visitedTimes is required": "请输入近期访问次数",
      "hadVisitedOther is required": "请选择是否访问过除韩国外的其他国家",
      "countryName is required": "请选择国家",
      "visitedPurpose is required": "Please enter the purpose of your visit",
      "visitedCountry is required": "Please enter visit country",
      "dateStart is required": "Please select a start date",
      "dateEnd is required": "Please select cut-off time",
      "haveFamily is required": "请选择是否有同行家属",
      "haveInKorea is required": "请选择是否有家属在韩居住",
      "familyName is required": "Please enter the name of your family in Korea",
      "familyBirthDate is required": "Please select the date of birth of your Korean family",
      "familyCountry is required": "Please enter the nationality of your family in Korea",
      "familyRelationship is required": "请选择在韩家属与申请人关系",
      "date is not correct": "结束日期不能早于开始日期",
      "Please enter other Immigration Arrangements": "Please enter other Immigration Arrangements",
      "Please select a date to go abroad": "Please select a date to go abroad",
      "Please enter your purpose of recent visit": "Please enter your purpose of recent visit"
    },
    save2nextBtn: "保存，并下一步"
  },
  saveOtherInfo: {
    invitation: {
      title: "Invitation information",
      question: "*Is there an invitation or an invitation unit in Korea？",
      yes: "YES",
      no: "NO",
      name: "*Invitee name or invite unit name",
      info: "*Date of invitation or registration number of invitee for flat-enterprise registration",
      contactRelation: "*Relationship with applicant",
      invitedAddress: "*Address of inviter or unit",
      mobile: "*phone number",
      invitedRelationship: "*邀请人与申请人的关系"
    },
    cost: {
      title: "expense information",
      question: "*谁将承担在韩国期间的费用",
      value1: "自己",
      value2: "邀请方",
      value3: "他人支付",
      paymentType: "*Payment type",
      cost: "*Expenses during the period in Korea (based on US dollars)",
      payerName: "*Name/unit (or team) name",
      payerRelationship: "*Please fill in the relationship between the payer and the applicant",
      "phone number": "*phone number"
    },
    assist: {
      title: "Helper information",
      question: "*Is there anyone who helped me fill out this application",
      yes: "YES",
      no: "NO",
      name: "*name",
      birthDate: "*Date of birth",
      mobile: "*phone number",
      contactRelation: "*Relationship with applicant",
      birthDatePlaceholder: "Date of birth"
    },
    rulesErr: {
      "haveInvited is required": "请选择是否在韩国有邀请人或邀请单位",
      "invitedName is required": "Please enter invitee name or invite unit name",
      "invitedInfo is required": "Please enter date of invitation or registration number of invitee for flat-enterprise registration",
      "invitedAddress is required": "Please enter relationship with applicant",
      "invitedContact is required": "Please enter inviter's phone number",
      "invitedRelationship is required": "Please enter relationship with applicant",
      "payType is required": "Please enter payment type",
      "cost is required": "Please enter expenses during the period in Korea",
      "payerName is required": "Please fill in the name/unit (or team) name",
      "costPayer is required": "请选择谁将承担在韩期间的费用",
      "payerRelationship is required": "Please fill in the relationship between the payer and the applicant",
      "haveHelper is required": "请选择是否有协助人",
      "helperName is required": "Please enter helper information",
      "helperBirthDate is required": "Please select the date of birth of the helper",
      "helperContact is required": " Please fill in the contact information of the helper ",
      "helperRelationship is required": "Please enter relationship with applicant",
      "Please enter the phone number": "Please enter the phone number",
    },
    save2nextBtn: "保存，并下一步"
  },
  /*---------------------------   申请人资料     --------------------------*/
  /*上传护照首页*/
  visaForm1: {
    title: "护照首页模板",
    container: {
      s1: "1、护照离出发日必须有6个月以上有效期",
      s2: "2、拍摄上传彩色的护照首页，字体清晰可见"
    },
    button: "点击开始拍照"
  },
  "visaForm1-1": {
    container: {
      s1: "以下内容为自动识别内容，请仔细检查，如有问题可直接修改",
    },
    form: {
      passportNum: {
        name: "护照号码",
        placeholder: "",
      },
      surnameZh: {
        name: "姓（中文）",
        placeholder: ""
      },
      nameZh: {
        name: "名（中文）",
        placeholder: ""
      },
      surnameEn: {
        name: "姓（英文）",
        placeholder: ""
      },
      nameEn: {
        name: "名（英文）",
        placeholder: ""
      },
      gender: {
        name: "性别",
        male: '男',
        female: '女'
      },
      birthDate: {
        name: "出生日期",
        placeholder: ""
      },
      birthPlaceZh: {
        name: "出生地点（中文）",
        placeholder: ""
      },
      birthPlaceEn: {
        name: "出生地点（英文）",
        placeholder: ""
      },
      issuancePlaceZh: {
        name: "签发地点（中文）",
        placeholder: ""
      },
      issuancePlaceEn: {
        name: "签发地点（英文）",
        placeholder: ""
      },
      issuanceDate: {
        name: "签发日期",
        placeholder: ""
      },
      issuancePeriod: {
        name: "有效期至",
        placeholder: ""
      },
    },
    "rulesErr": {
      'passportNum is required': "Please fill in your passport number",
      "surnameZh is required": "请填写姓（中文）",
      "surnameEn is required": "请填写姓（英文）",
      "nameZh is required": "请填写名（中文）",
      "nameEn is required": "请填写姓（英文）",
      "birthPlaceZh is required": "出生地点（中文）",
      "birthPlaceEn is required": "出生地点（英文）",
      "issuancePlaceZh is required": "请填写签发地点（中文）",
      "issuancePlaceEn is required": "请填写签发地点（英文）",
    },
    reUploadBtn: "重新上传",
    save2next: "保存，并下一步"
  },
  /*上传身份证*/
  "visaForm2": {
    IDCard: {
      s1: "身份证人像面",
      s2: "身份证国徽面",
      s3: "点击开始拍照",
      instructions: {
        s1: "1、清晰拍摄正反面、不能反光",
        s2: "2、请注意露出四个边角，不要压边拍摄",
        s3: "3、临时身份证不可申请签证",
      }
    },
    minor: {
      title: "未成年儿童，未办理身份证",
      instructions: "提醒 ：未成年儿童，未办理身份证时，邮寄材料里需要提供出生医学证明复印件，并上传原件照片。"
    },
    saveBtn: "保存，并下一步"
  },
  /*上传电子照片*/
  "visaForm3": {
    title: "上传电子照片",
    instructions: {
      s1: "1、近6个月内拍摄的2寸(3.5cmx4.5cm)白底彩照;",
      s2: "2. 邮寄申请资料里必须和电子照片一致。",
      s3: "3、不得佩戴眼镜、夸张首饰，不得穿着制服;双眼直视照相机;露出双耳;",
      s4: "嘴巴闭合;头发不能遮住两眼;左右肩膀保持平衡;",
      s5: "4、不能因容貌变化、相片变色、褪色等原因,与目前容貌发生明显差异。",
      s6: "*我们提供照片自助拍摄和打印服务,请在下单时选择",
    },
    takePhotoBtn: "点击开始拍照",
    uploadPhotoBtn: "我已有签证照，直接上传"
  },
  "visaForm3-1": {
    title: "上传电子照片",
    uploadSu: "电子照片已上传",
    instructions: {
      s1: "1、近6个月内拍摄的2寸(3.5cmx4.5cm)白底彩照;",
      s2: "2. 邮寄申请资料里必须和电子照片一致。",
      s3: "3、不得佩戴眼镜、夸张首饰，不得穿着制服;双眼直视照相机;露出双耳;",
      s4: "嘴巴闭合;头发不能遮住两眼;左右肩膀保持平衡;",
      s5: "4、不能因容貌变化、相片变色、褪色等原因,与目前容貌发生明显差异。",
      s6: "*我们提供照片自助拍摄和打印服务,请在下单时选择",
    },
    reUploadBtn: "重新上传",
    save2nextBtn: "保存，并下一步"
  },
  /*个人信息*/
  "visaForm4": {
    "question1": "*是否曾用别名入境韩国或从韩国出境？",
    "surnameZh": "姓（中文）",
    "nameZh": "名（中文）",
    "question2": "*是否拥有双重国籍？",
    "orderNationality": "*其它国家国籍",
    "orderNationalityPlaceholder": "请输入国家名称",
    "question3": "*是否持有其它护照？",
    "question4": "*其它护照类型",
    "passportType": {
      "type1": "外交护照",
      "type2": "公务护照",
      "type3": "普通护照",
      "type4": "其它"
    },
    "passportNum": {
      name: "*护照号码",
      placeholder: "请输入护照号码"
    },
    "issuancePlace": {
      name: "*签发地点",
      placeholder: "请输入签发地点"
    },
    issuancePeriod: {
      name: "*有效期至",
      placeholder: "请输入有效期"
    },
    "issuanceOrg": {
      name: "*签发机关",
      placeholder: "请输入签发机关"
    },
    rulesErr: {
      "surnameZh is required": "请填写姓（中文）",
      "nameZh is required": "请填写名（中文）",
      "orderNationality is required": "请输入国家名称",
      "passportNum is required": "请输入护照号码",
      "issuancePlace is required": "请输入签发地点",
      "issuancePeriod is required": "请输入有效期",
      "issuanceOrg is required": "请输入签发机关",
    },
    "yes": "是",
    "no": "否",
    "save2nextBtn": "保存，并下一步"
  },
  /*联系人信息*/
  "visaForm5": {
    description: "填写申请表时，请填写真实有效信息，否则将导致拒签",
    address: "*本国住址",
    addressPlaceholder: "请输入本国地址",
    nowAddress: "*现居住地址",
    nowAddressPlaceholder: "请输入现居住地址",
    mobile: "*手机",
    mobilePlaceholder: "请输入手机号码",
    telephone: "*电话",
    telephonePlaceholder: "请输入电话号码",
    email: "*邮箱",
    emailPlaceholder: "请输入邮箱",
    emergencyContact: "*紧急联系人",
    contactName: "*姓名",
    contactNamePlaceholder: "请输入紧急联系人姓名",
    contactMobile: "*电话",
    contactMobilePlaceholder: "请输入紧急联系人电话",
    contactNation: "*居住国家",
    contactRelation: "*与申请人关系",
    save2nextBtn: "保存，并下一步",
    rulesErr: {
      "address is required": "请输入本国地址",
      "nowAddress is required": "请输入现居住地址",
      "mobile is required": "请输入手机号码",
      "telephone is required": "请输入电话号码",
      "email is required": "请输入邮箱",
      "contactName is required": "请输入紧急联系人姓名",
      "contactMobile is required": "请输入紧急联系人电话",
      "contactNationValue is required": "请选择居住国家",
      "contactRelationValue is required": "请选择与联系人关系",
    }
  },
  /*家庭成员信息*/
  "visaForm6": {
    maritalStatus: {
      title: "*婚姻状况",
      status1: "已婚",
      status2: "未婚",
      status3: "单身",
    },
    spouseInfo: {
      title: "*配偶信息",
      surnameZh: "姓（中文）",
      surnameZhPlaceholder: "请输入配偶姓",
      nameZh: "名（中文）",
      nameZhPlaceholder: "请输入配偶名",
      birthDate: "*出生日期",
      birthDatePlaceholder: "请选择出生日期",
      nationality: "*国籍",
      mobile: "*电话",
      mobilePlaceholder: "请输入配偶电话",
      address: "*居住地址",
      addressPlaceholder: "请输入居住地址"
    },
    rulesErr: {
      "surnameZh is required": "请输入配偶姓",
      "nameZh is required": "请输入配偶名",
      "birthDate is required": "请选择出生日期",
      "contactNationValue is required": "请选择国籍",
      "mobile is required": "请输入配偶电话",
      "address is required": "请输入居住地址",
    },
    save2nextBtn: "保存，并下一步"
  },
  /*教育信息*/
  "visaForm7": {
    educationBg: {
      title: "*最高学历",
      value1: "硕士/博士",
      value2: "学士",
      value3: "高中",
      value4: "其它",
    },
    otherEducationBg: "*其它学历，请说明",
    schoolName: "*学校名称",
    schoolLocation: "*学校所在地",
    profession: {
      title: "*当前职业",
      value1: "事业家",
      value2: "自雇",
      value3: "公司职员",
      value4: "公务员",
      value5: "学生",
      value6: "无业",
      value7: "退休",
      value8: "其它",
    },
    rulesErr: {
      "otherEducationBg is required": "请输入其他学历说明",
      "schoolName is required": "请输入学校名称",
      "schoolLocation is required": "请输入学校所在地",
      "occupationDescription is required": "请输入其他职业说明",
    },
    occupationDescription: "其他职业说明",
    otherProfession: "*其它职业，请说明",
    save2nextBtn: "保存，并下一步"
  },
  /*访问信息*/
  "visaForm8": {
    access: {
      date: "*拟入境日期",
      datePlaceholder: "拟入境日期",
      days: "*拟滞留天数",
      mobile: "*在韩联系电话",
      address: "*在韩滞留地址/酒店"
    },
    families: {
      question: "*是否有同行家属？",
      yes: "是",
      no: "否",
      family: {
        title: "*同行家属",
        name: "*姓名",
        birthDate: "*出生日期",
        nationality: "*国籍",
        contactRelation: "*与申请人关系"
      }
    },
    records: {
      question1: "*近五年内是否访问过韩国？",
      count: "*五年内访韩次数",
      purpose: "*近期入境目的",
      question2: "*近五年内是否访问过除韩国外其它国家？",
      countries: {
        title: "其它访问国家",
        name: "*国家名称",
        purpose: "*访问目的",
        period: "有效期"
      },
      dateStartPlaceholder: "开始时间",
      dateEndPlaceholder: "截止时间",
      yes: "是",
      no: "否",
    },
    rulesErr: {
      "date is required": "请选择拟入境日期",
      "days is required": "请填写拟滞留天数",
      "mobile is required": "请填写在韩联系电话",
      "address is required": "请填写在韩滞留地址",
      "name is required": "请填写同行家属姓名",
      "birthDate is required": "请选择同行家属生日",
      "country is required": "请选择同行家属国籍",
      "relationship is required": "请选择与同行家属关系",
      "visitedValue is required": "请选择近期访问次数",
      "visitedPurposeValue is required": "请选择近期访问目的",
      "countryName is required": "请选择国家",
      "visitedPurpose is required": "请选择访问目的",
      "dateStart is required": "请选择开始日期",
      "dateEnd is required": "请选择截止日期",
    },
    save2nextBtn: "保存，并下一步"
  },
  /*其他信息*/
  visaForm9: {
    invitation: {
      question: "*是否在韩国有邀请人或邀请单位？",
      yes: "是",
      no: "否",
      name: "*邀请人姓名或邀请单位名",
      info: "*邀请人出生日期或邀请单位登记证号码",
      contactRelation: "*与申请人关系",
      invitedAddress: "*邀请人或邀请单位地址",
      mobile: "*联系电话"
    },
    cost: {
      question: "*谁将承担在韩国期间的费用",
      value1: "自己",
      value2: "邀请方",
      value3: "他人支付",
      paymentType: "*支付类型",
      cost: "*在韩期间费用（以美元为准）",
      payerName: "*姓名/单位（或团队）名称",
      payerRelationship: "*费用承担者与申请人关系"
    },
    assist: {
      question: "*是否有人协助填写本申请",
      yes: "是",
      no: "否",
      name: "*姓名",
      birthDate: "*出生日期",
      mobile: "*电话",
      contactRelation: "*与申请人关系",
      birthDatePlaceholder: "出生日期"
    },
    rulesErr: {
      "invitedName is required": "请填写邀请人姓名或邀请单位名",
      "invitedInfo is required": "请填写邀请人出生日期或邀请单位登记证号码",
      "invitedAddress is required": "请填写邀请人或邀请单位地址",
      "invitedContact is required": "请填写邀请人联系电话",
      "payType is required": "请填写支付类型",
      "cost is required": "请填写在韩期间费用",
      "payerName is required": "请填写姓名/单位（或团队）名称",
      "payerRelationship is required": "请选择费用承担者与申请人关系",
      "helperName is required": "请填写协助人姓名",
      "helperBirthDate is required": "请选择协助人的出生日期",
      "helperContact is required": "请填写协助人的联系方式",
      "helperRelationship is required": "请选择与协助人的关系",
    },
    save2nextBtn: "保存，并下一步"
  },
  /*其他材料*/
  visaForm10: {
    business: {
      title: "请上传公司营业执照",
      toDetail: "查看样图",
      uploadBtn: "点击上传",
      selectBtn: "从最近上传记录里选择",
      instructions: {
        s1: "说明：",
        s2: "1. 营业执照务必清晰",
        s3: "2. 必须加盖公司公章",
        s4: "3. 仅支持png/jpg格式图片",
        s5: "4. 图片大小不得超过500kb",
      }
    },
    invitation: {
      title: "请上传韩方邀请函图片（含邀请事由和归国保证书等内容）",
      toDetail: "查看样图",
      uploadBtn: "点击上传",
      selectBtn: "从最近上传记录里选择",
      instructions: {
        s1: "说明：",
        s2: "1. 邀请公函务必清晰",
        s3: "2. 必须加盖公司公章",
        s4: "3. 仅支持png/jpg格式图片",
        s5: "4. 图片大小不得超过500kb",
      }
    },
    registered: {
      title: "",
      toDetail: "查看样图",
      uploadBtn: "点击上传",
      selectBtn: "从最近上传记录里选择",
      instructions: {
        s1: "",
        s2: "",
        s3: "",
        s4: "",
        s5: "",
      }
    },
    verification: {
      title: "",
      placeholder: "",
    },
    lawDesc: "",
    save2nextBtn: "保存，并下一步"
  },
  /*寄送方式*/
  sendWay: {
    "Confirm delivery and payment information": "Confirm delivery and payment information",
    "To apply for together": "To apply for together",

    "outgoing courier information": "outgoing courier information",
    desc: "Please select the way to send the file. Please delete any applicants who have not applied.",
    "Use express delivery": "Use express delivery",
    "To visit the center": "To visit the center",
    "Sender name": "*Sender's name",
    "Mobile phone number": "*Mobile phone number",
    "Select area": "*Select area",
    "Detailed address": "*Detailed address",
    "Commonly used address": "Commonly used address",


    "Appointment Information": "Appointment Information",
    "Number of general visa applications": "Number of general visa applications",
    "Number of urgent visa applications": "Number of urgent visa applications",
    "Name of sender": "Name of sender",
    "phone number": "phone number",
    "Relationship with applicant": "Relationship with applicant",
    "Estimated time of visit": "Estimated time of visit",
    "exit date": "exit date",
    "Select Date": "Select Date",
    "Please select a date to make a reservation visit": "Please select a date to make a reservation visit",
    "Please select a time to make a reservation visit": "Please select a time to make a reservation visit",
    "Appointment reminders": "Appointment reminders",
    "Please enter the sender name": "Please enter the sender’s name",
    "Please enter your mobile phone number": "Please enter your mobile phone number",
    "Please select a estimated time of visit": "Please select a estimated time of visit",
    "Please select a date to go abroad": "Please select a date to go abroad",
    "Check and go to next page": "Check and go to next page",
    state: {
      Myself: "Myself",
      "Family members": "Family members"
    },
    way: {
      type1: "使用快递寄送材料",
      type2: "自己送材料到签证中心"
    },
    sendList: {
      name: "*发件人姓名",
      phone: "*手机号",
      area: "*选择地区",
      provinceId: "请选择省",
      cityId: "请选择市",
      districtId: "请选择区",
      address: "详细地址",
      addAddress: "自动添加到常用地址",
      selectAddress: "选择常用地址"
    },
    reserveTime: {
      selectDate1: "选择预约材料日期",
      selectDate2: "选择预约材料时间",
      reserveTimePlaceholder: "请选择预约日期",
    },
    notice: {
      title: "预约须知",
      s1: "※ 网上预约者请务必准备好申请资料，可大大减少您申请签证的等待时间，继而提高资料接收效率。",
      s2: "网上预约可预约2个工作日之后的日期（工作日基准）",
      s3: "例：今天是12月1日，可申请预约12月3日及以后的日期；",
      s4: " ①  网上预约开放时间为当月及后续两个月，",
      s5: "例：2016年1月时，系统开放可预约时间至3月，如此类推；",
      s6: "②  预约成功前来签证中心申请时，请携带预约确认单；",
      s7: "③  同一个户口本的直系亲属（2寸以内）可由网上预约申请者代理申请签证；",
      s8: "④  同一个预约号码的其他申请者（非直系亲属）一定要本人及网上预约申请者一起到签证申请中心方可办理签证；",
      s9: "⑤  网上预约者不可重复申请预约，重复的预约将会被取消；",
      s10: "* 签证申请时，若因资料不足或不符，签证中心可不予以接收，因此申请人请务必事先准备好所需资料",
    },
    btn: {
      btn1: "查看所需资料内容",
      btn2: "所需资料发送到邮箱"
    },
    rulesErr: {
      "name is required": "Please fill in the sender's name",
      "phone is required": "Please fill in the sender's phone number",
      "address is required": "Please fill in the sender's address",
      "sendType is required": "请选择寄送方式",
      "provinceId is required": "请选择省份",
      "cityId is required": "请选择城市",
      "districtId is required": "请选择市区",
      "sendListReserveTime is required": "请选择自送预约日期",
    }

  },
  receiveWay: {
    "working hours": "working hours", "address": "address", "phone number": "phone number", "e-mail": "e-mail",
    "Confirm delivery and payment information": "Confirm delivery and payment information",
    "Return Delivery Information": "Return Delivery Information",
    "Choose express": "Choose express",
    "Visit the center to receive documents": "Visit the center to receive documents",
    "returning address": "returning address",
    "The recipient": "*The recipient",
    "Mobile phone number": "*Mobile phone number",
    "Please select district": "*Please select district",
    "Detailed address": "*Detailed address",
    "Commonly used address": "Commonly used address",
    "Add Return Address": "Add Return Address",
    "Please select an application to return to your address now": "Please select an application to return to your address now",
    "Confirm the payment": "Confirm the payment",
    "Are you sure of payment": "Are you sure of payment",
    way: {
      title: "请选择取件方式",
      type1: "使用快递回寄地址",
      type2: "签证中心自取件"
    },
    receiveAddress: {
      title: "回寄地址",
      btn1: "编辑地址",
      btn2: "使用常用地址"
    },
    selectApply: {
      title: "请选择申请人",
      desc: "出签后下列申请人的资料会一同寄回当前地址"
    },
    addAddressBtn: "增加签证回寄地址",
    rulesErr: {
      "name is required": "请填写收件人姓名",
      "phone is required": "请填写收件人联系方式",
      "province is required": "请选择省份",
      "city is required": "请选择城市",
      "district is required": "请选择县区",
      "address is required": "请填写收件人详细地址",
    }
  },
  confirmPay: {
    "Confirm payment information": "Confirm payment information",
    "Delivery charge": "Delivery charge",
    "Delivery check": "Delivery check",
    "return express fee": "return express fee",
    "Payment amount": "Payment amount",
    "payment method": "payment method",
    "alipay": "alipay",
    "WeChat pay": "WeChat pay",
    "To check and pay": "To check and pay"
  },
  newAddress: {
    name: {
      title: "联系人",
      placeholder: "请输入联系人姓名"
    },
    phone: {
      title: "手机号码",
      placeholder: "请输入手机号码"
    },
    address: {
      title: "选择地址",
      placeholder: "请选择地址"
    },
    completeAddress: {
      title: "详细地址",
      placeholder: "请输入详细地址"
    },
    rulesErr: {
      "name is required": "请填写联系人姓名",
      "phone is required": "请填写联系人手机号",
      "provinceid is required": "请选择省份",
      "cityId is required": "请选择城市",
      "districtid is required": "请选择市区",
      "completeAddress is required": "请填写详细地址",
    },
    confirmBtn: "确定"
  },
  saveBasicInfo: {
    "Visa application information": "Visa application information",
    "Upload basic information": "Upload basic information",
    "Submit application information": "Submit application information",
    "View and save application information": "View and save application information",
    "Upload passport": "Upload passport",
    "attention": "attention ：When the passport photo is not clear",
  },
  saveApplyInfo: {
    "Visa application information": "Visa application information",
    "Upload basic information": "Upload basic information",
    "Submit application information": "Submit application information",
    "View and save application information": "View and save application information",
    "Check and go to the next page": "Check and go to the next page",

    "Please check if the personal information is correct": "Please check if the personal information is correct",
    "Please check if the Contact information is correct": "Please check if the Contact information is correct",
    "Please check if the marital status and family member information is correct": "Please check if the marital status and family member information is correct",
    "Please check if the educational information is correct": "Please check if the educational information is correct",
    "Please check if the job information is correct": "Please check if the job information is correct",
    "Please check if the visit information is correct": "Please check if the visit information is correct",
    "Please check if the invitation information is correct": "Please check if the invitation information is correct",
    "Please check if the expense information is correct": "Please check if the expense information is correct",
    "Save success": "Save success",
  },
  confirmApply: {
    /*签证信息*/
    "Visa application information": "Visa application information",
    "Upload basic information": "Upload basic information",
    "Submit application information": "Submit application information",
    "View and save application information": "View and save application information",
    "attention": "attention : Please verify the following information carefully.Cannot be modified after presentation.",
    "Application information": "Application information",
    "the place where you live and work": "the place where you live and work",
    "Your application will be submitted to": "Your application will be submitted to",
    "Visa type": "Visa type",
    "Visa entries": "Visa entries",
    "The urgent": "The urgent ",
    "Modify": "Modify",


    "Please check the exact data": "Please check the exact data",
    "Please enter the applicant name": "Please enter the applicant's name",
    "Confirm that the name is used for the signature of the application form": "Confirm that the name is used for the signature of the application form",

    /*护照信息*/
    passport: {
      "Passport information": "Passport information",
      "Modify": "Modify",
      "Passport number": "Passport number",
      "The surname（Chinese）": "The surname（Chinese）",
      "Name（Chinese）": "Name（Chinese）",
      "Family Name（English）": "Family Name（English）",
      "Given Name（English）": "Given Name（English）",
      "gender": "gender",
      "Date of birth": "Date of birth",
      "Place of birth": "Place of birth",
      "Country of birth": "Country of birth",
      "Date of Issue": "Date of Issue",
      "place of issue": "place of issue",
      "Validity Period": "Validity Period",
    },

    /*身份证信息*/
    idCard: {
      "ID information": "ID information",
      "Modify": "Modify",
      "Name": "Name",
      "gender": "gender",
      "ethnic groups": "ethnic groups",
      "Date of birth": "Date of birth",
      "address": "address",
      "Id card number": "Id card number",
      "issuing authority": "issuing authority",
      "Validity Period": "Validity Period",
    },
    /*个人信息*/
    personal: {
      "personal information": "personal information",
      "Modify": "Modify",
      "Have you entered or left Korea under any other name?": "Have you entered or left Korea under any other name?",
      "YES": "YES",
      "NO": "NO",
      "Other Name (the surname)": "Other Name (the surname)",
      "Other Name(name)": "Other Name(name)",
      "Whether you have dual nationality": "Whether you have dual nationality",
      "Nationality of other countries": "Nationality of other countries",
      "Do you have other passports?": "Do you have other passports?",
      "Other passport types": "Other passport types",
      "Passport number": "Passport number",
      "issuing country": "issuing country",
      "Validity Period": "Validity Period",
    },
    /*联系信息*/
    contact: {
      "Contact Information": "Contact Information",
      "Modify": "Modify",
      "Home address": "Home address",
      "Current residential address": "Current residential address",
      "Mobile phone number": "Mobile phone number",
      "phone number": "phone number",
      "e-mail": "e-mail",
      "Emergency contact information": "Emergency contact information",
      "Name": "Name",
      "Country of residence": "Country of residence",
      "Relationship with the applicant": "Relationship with the applicant",
    },
    /*家庭成员*/
    member: {
      "Marital status and family member information": "Family member information",
      "Modify": "Modify ",
      "Marital status": "Marital status",
      "spouse information": "spouse information",
      "Family Name": "Family Name",
      "Given Name": "Given Name ",
      "Date of birth": "Date of birth",
      "Nationality": "Nationality",
      "residential address": "residential address",
      "phone number": "phone number",
      "Have children or not": "Have children or not",
      "NO": "NO",
      "YES": "YES",
      "the number of children": "the number of children",
      state: {
        "married": "married",
        "divorce": "divorce",
        "single": "single",
      }
    },
    /*教育信息*/
    educational: {
      "educational information": "educational information",
      "Modify": "Modify",
      "the highest academic qualifications": "the highest academic qualifications",
      "School name": "School name",
      "School location": "School location",
      "Other qualifications please specify": "Other qualifications please specify",
      state: {
        "Master": "Master/doctor",
        "Bachelor": "Bachelor's degree",
        "High school": "High school",
        "other": "other",
      }
    },
    /*职业信息*/
    professional: {
      "Professional information": "Professional information",
      "The current career": "The current career",
      "Name of company/agency/school": "Name of company/agency/school",
      "Occupation/course": "Occupation/course",
      "Company/office/school address": "Company/office/school address",
      "Company/office/school contact number": "Company/office/school contact number",
      "Other job description": "Other job description",
      state: {
        "entrepreneurs": "entrepreneurs",
        "self-employment": "self-employment",
        "Company employees": "Company employees",
        "Civil servants": "Civil servants",
        "students": "students",
        "unemployed": "unemployed",
        "retired": "retired",
        "other": "other",
      }
    },
    /*访问信息*/
    access: {
      "access information": "access information",
      "days of detention": "days of detention",
      "Intended date of entry": "Intended date of entry",
      "Date of departure": "Date of departure",
      "Contact number in Korea": "Contact number in Korea",
      "Address/hotel in Korea": "Address/hotel in Korea",
      "Application for entry": "Application for entry",
      "Are there any family members with you?": "Are there any family members with you?",
      "NO": "NO",
      "YES": "YES",
      "name(pinyin)": "name(pinyin)",
      "Date of birth": "Date of birth",
      "nationality": "nationality",
      "Relationship with applicant": "Relationship with applicant",
      "Are there any family members living in Korea?": "Are there any family members living in Korea?",
      relationshipState: {
        "spouse": "spouse",
        "children": "children",
        "parents": "parents",
        "Brothers and sisters": "Brothers and sisters",
      },
      Application: {
        title: "*Application for entry",
        value1: "tours /transit",
        value2: "attend a meeting,etc",
        value3: "Medical tourism",
        value4: "Short-term business",
        value5: "Learning/training",
        value6: "Employment activities",
        value7: "Trade/investment/Posting",
        value8: "to visit relatives/friends",
        value9: "to marry/immigrate",
        value10: "foreign/public affairs",
        value11: "Other",
        other: "Other Immigration Arrangements",
        otherPlaceholder: "Please enter other Immigration Arrangements"
      },
      "Have you visited the rok in the past five years?": "Have you visited any other countries other than Korea in the last five years?",
      "Recent Entry Purpose": "Recent Entry Purpose",
      "Have you visited any other countries other than Korea in the last five years?": "Have you visited any other countries other than Korea in the last five years?",
      "Country name": "Country name",
      "Visit purpose": "Visit purpose",
      "During the visit": "During the visit",
    },
    /*邀请方信息*/
    invitation: {
      "Invitation information": "Invitation information",
      "Modify": "Modify",
      "Is there an invitation or an invitation unit in Korea?": "Is there an invitation or an invitation unit in Korea?",
      "NO": "NO",
      "YES": "YES",
      "Invitee name or invite unit name": "Invitee name or invite unit name",
      "Date of invitation or registration number of invitee for flat-enterprise registration": "Date of invitation or registration number of invitee for flat-enterprise registration",
      "Relationship with applicant": "Relationship with applicant",
      "Address of inviter or unit": "Address of inviter or unit",
      "phone number": "phone number",
    },
    /*费用信息*/
    cost: {
      "expense information": "expense information",
      "Modify": "Modify",
      "Expenses during the period in Korea (based on US dollars)": "Expenses during the period in Korea (based on US dollars)",
      "Payment type": "Payment type",
      "Name/unit (or team) name": "Name/unit (or team) name",
      "The relationship between the undertaker and the applicant": "The relationship between the undertaker and the applicant",
      "phone number": "phone number",
    },
    /*协助*/
    Helper: {
      "Helper information": "Helper information",
      "Modify": "Modify",
      "Is there anyone who helped me fill out this application?": "Is there anyone who helped me fill out this application?",
      "name": "name",
      "Date of birth": "Date of birth",
      "phone number": "phone number",
      "Relationship with applicant": "Relationship with applicant",
    },
    "Required materials": "Required materials",
    "Click to view the required materials": "Click to view the required materials",
    "Send required information to mailbox": "Send required information to mailbox",
    confirmed: "I declare that I have confirmed that the contents of the form are true and accurate and that I have pledged to abide by the relevant regulations of the Law of the Republic of Korea on the Administration of Entry and Exit.",
    confirmBtn: "Confirm the information",
    "View the application": "View the application",
    "Please sign the QR code on your phone": "Please sign the QR code on your phone.",
    "Please sign the QR code with WeChat": "Please sign the QR code with WeChat.",
    cancelBtn: "cancel",
    signed: "signed"
  },
  /*---------------------------   公共     --------------------------*/
  "common": {
    /*toast*/
    "toastLoading": "正在加载...",
    "toastWait": "请稍后...",
    /*loading*/
    "loading": "加载中...",
    "finished": "没有更多数据了",
    "loadErr": "加载失败,点击重试",
    /*select*/
    "pleaseSelect": "请选择"
  }
}




// WEBPACK FOOTER //
// ./src/assets/languages/en.js